import {SoundsService} from "../../services/SoundsService";
import {sounds} from "../../sounds/sound";
import {useTypedSelector} from "../../hooks/useTypedSelector";
import {useActions} from "../../hooks/useActions";

function ButtonCloseMainPopup() {

    const {tutorial} = useTypedSelector(state => state.auth);
    const {setTutorial, setRoute} = useActions();

    let coreClasses = 'buttonCloseMainPopup';
    if (
        tutorial.step === 'MenuResearch90'
        || tutorial.step === 'ClickDeck110'
        || tutorial.step === 'ClickHome140'
    ) {
        coreClasses += ' defaultButtonAnimation_2_5';
    }

    if (
        tutorial.step === 'BossWindow30'

    ) {
        coreClasses += ' buttonCloseMainPopupGrey';
    }

    return <div className={coreClasses}
                onClick={() => {
                    /// tutorial
                    if (tutorial.isActive && tutorial.step === 'MenuResearch90') {
                        tutorial.step = 'ClickOffers95';
                        setTutorial(tutorial);
                    }
                    if (tutorial.isActive && tutorial.step === 'ClickDeck110') {
                        tutorial.step = 'ClickBuy120';
                        setTutorial(tutorial);
                    }
                    if (tutorial.isActive && tutorial.step === 'ClickHome140') {
                        tutorial.step = 'Final150';
                        setTutorial(tutorial);
                    }
                    /// tutorial end

                    SoundsService.playSound(sounds.menu_close_popup());
                    setRoute('home');
                }}
    ></div>
}

export default ButtonCloseMainPopup;